import { render } from "./SellerLayout.vue?vue&type=template&id=6b2a39df&scoped=true"
import script from "./SellerLayout.vue?vue&type=script&lang=js"
export * from "./SellerLayout.vue?vue&type=script&lang=js"

import "./SellerLayout.vue?vue&type=style&index=0&id=6b2a39df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2a39df"]])

export default __exports__